export const sidenavSections = [
  {
    id: 'modules',
    title: 'MÓDULOS',
    icon: 'ri-apps-2-line',
    items: [
      {
        id: 'welcome',
        text: 'Inicio',
        route: { name: 'Welcome' },
        icon: 'HomeIcon',
        alwaysVisible: true,
        description: 'Página principal de bienvenida'
      },
      {
        id: 'bulk_update',
        text: 'Actualización Masiva',
        route: { name: 'ActualizacionMasiva' },
        icon: 'BulkUpdateIcon',
        permission: 'bulk_update',
        description: 'Herramienta de actualización masiva de datos'
      },
      {
        id: 'master_4tool',
        text: 'Master 4Tool',
        route: { name: 'Master4Tool' },
        icon: 'Master4ToolIcon',
        permission: 'master_4tool',
        description: 'Herramienta maestra para gestión avanzada'
      },
      {
        id: 'permisos_4tool',
        text: 'Permisos 4Tool',
        route: { name: 'Permisos4Tool' },
        icon: 'ri-shield-user-line',
        permission: 'permisos_4tool',
        description: 'Gestión de permisos y roles del sistema 4Tool'
      },
      {
        id: 'delete_records',
        text: 'Borrado Registros',
        route: { name: 'BorradoRegistros' },
        icon: 'TrashIcon',
        permission: 'delete_records',
        description: 'Herramienta para borrado de registros'
      },
      {
        id: 'cargas_masivas_v2',
        text: 'Cargas Masivas V2',
        route: { name: 'CargasMasivasV2' },
        icon: 'TrashIcon',
        permission: 'bulk_loads',
        description: 'Versión dos de cargas masivas'
      }
    ]
  },
  {
    id: 'admin',
    title: 'ADMIN',
    icon: 'ri-settings-3-line',
      requiresAnyPermission: ['activity', 'users', 'panel_admin', 'cargar_export', 'permisos_4tool'],
    items: [
      {
        id: 'cargar_export',
        text: 'Cargar Export',
        route: { name: 'CargarExport' },
        icon: 'UploadIcon',
        permission: 'cargar_export',
        description: 'Carga de archivos de exportación',
        subitems: [
          {
            id: 'historial_cargas',
            text: 'Cargas realizadas',
            route: { name: 'HistorialCargas' },
            icon: 'ri-history-line',
            permission: 'cargar_export',
            description: 'Historial de cargas realizadas',
            isSubitem: true
          }
        ]
      },
      {
        id: 'activity',
        text: 'Actividad',
        route: { name: 'Activity' },
        icon: 'ActivityIcon',
        permission: 'activity',
        description: 'Registro de actividad del sistema'
      },
      {
        id: 'users',
        text: 'Usuarios',
        route: { name: 'Users' },
        icon: 'CustomerSupport',
        permission: 'users',
        description: 'Gestión de usuarios del sistema'
      },
      {
        id: 'admin_panel',
        text: 'Panel Admin',
        route: { name: 'PanelAdmin' },
        icon: 'Office',
        permission: 'panel_admin',
        description: 'Panel de administración general'
      }
    ]
  },
  {
    id: 'configuration',
    title: 'CONFIGURACIÓN',
    icon: 'ri-settings-2-line',
    requiresAnyPermission: ['settings', 'preferences', 'config', 'system_config'],
    items: []
  }
]

export const getVisibleSections = (hasPermissionFn) => {
  return sidenavSections.filter(section => {
    if (section.requiresAnyPermission) {
      return section.requiresAnyPermission.some(permission => hasPermissionFn(permission))
    }
    
    const visibleItems = getVisibleItems(section.items, hasPermissionFn)
    return visibleItems.length > 0
  })
}

export const getVisibleItems = (items, hasPermissionFn) => {
  return items.filter(item => {
    if (item.alwaysVisible) return true
    if (item.permission) return hasPermissionFn(item.permission)
    return false
  })
}

export const componentMap = {
  Shop: () => import('@/components/Icon/Shop.vue'),
  Office: () => import('@/components/Icon/Office.vue'),
  CreditCard: () => import('@/components/Icon/CreditCard.vue'),
  Switches: () => import('@/components/Icon/Switches.vue'),
  TrashIcon: () => import('@/components/Icon/TrashIcon.vue'),
  BulkUpdateIcon: () => import('@/components/Icon/BulkUpdateIcon.vue'),
  ActivityIcon: () => import('@/components/Icon/ActivityIcon.vue'),
  UploadIcon: () => import('@/components/Icon/UploadIcon.vue'),
  HomeIcon: () => import('@/components/Icon/HomeIcon.vue'),
  TaskIcon: () => import('@/components/Icon/TaskIcon.vue'),
  Master4ToolIcon: () => import('@/components/Icon/Master4ToolIcon.vue'),
  ListStars: () => import('@/components/Icon/ListStars.vue'),
  Pencil: () => import('@/components/Icon/Pencil.vue'),
  BookMark: () => import('@/components/Icon/BookMark.vue'),
  CustomerSupport: () => import('@/components/Icon/CustomerSupport.vue')
}

export const preloadCriticalIcons = async () => {
  const criticalIcons = ['HomeIcon', 'Shop']
  return Promise.all(
    criticalIcons.map(iconName => componentMap[iconName]?.())
  )
}